export class Dom {
  static DROPDOWNS_SELECTOR = '[data-dropdown]'
  static DROPDOWN_DETAILS_SELECTOR = '[data-dropdown-for]'
  static ACTIVE_CLASS = 'dropdown__link--active'
  static DETAILS_ACTIVE_CLASS = 'dropdown__details--active'

  get allDropdowns() {
    return document.querySelectorAll(Dom.DROPDOWNS_SELECTOR)
  }

  dropdownDetails = element => {
    const { dropdown } = element.dataset
    const dropdownDetailsSelector = `[data-dropdown-for='${dropdown}']`

    if (dropdown) {
      return document.querySelector(dropdownDetailsSelector)
    }
  }

  isActive = element => {
    return element.classList.contains(Dom.ACTIVE_CLASS)
  }

  isOutsideDropdown = element => {
    return (
      !element.closest(`.${Dom.ACTIVE_CLASS}`) && !element.closest(`.${Dom.DETAILS_ACTIVE_CLASS}`)
    )
  }

  inactivateAllActiveDropdowns = () => {
    const allActiveDropdowns = document.querySelectorAll(`.${Dom.ACTIVE_CLASS}`)

    allActiveDropdowns.forEach(activeDropdown => this.inactivate(activeDropdown))
  }

  inactivate = element => {
    const details = this.dropdownDetails(element)

    if (details) {
      details.classList.remove(Dom.DETAILS_ACTIVE_CLASS)
    }

    element.classList.remove(Dom.ACTIVE_CLASS)
  }

  activate = element => {
    const details = this.dropdownDetails(element)

    if (details) {
      details.classList.add(Dom.DETAILS_ACTIVE_CLASS)
    }

    element.classList.add(Dom.ACTIVE_CLASS)
  }
}
